import type { AxiosError } from 'axios';
import type { DocumentPickerAsset } from 'expo-document-picker';
import type { ImagePickerAsset } from 'expo-image-picker';
import { Platform } from 'react-native';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = {
  images: ImagePickerAsset[] | DocumentPickerAsset[] | File[];
};
export type ValidatePaymentMethodResponse = {};

export const useValidatePaymentMethod = createMutation<
  ValidatePaymentMethodResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) => {
    const formData = new FormData();

    variables.images.forEach(
      (image: ImagePickerAsset | DocumentPickerAsset | File) => {
        if (Platform.OS === 'web') {
          formData.append('verify_payment_photos[]', image);
        } else {
          formData.append('verify_payment_photos[]', {
            uri: image.uri,
            name: image.fileName || image.name,
            type: image.mimeType || 'image/jpeg',
          });
        }
      }
    );

    return client({
      url: `v2/customers/payment-photo/validate`,
      method: 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      });
  },
});
